import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';

const initialState = {
  industryMappingDetailList: [],
  DossierListTable: [],
  MappingSchemaTable: [],
  loading: false,
  error: null,
};

// Fetch Industry Mapping Detail List
export const fetchIndustryMappingDetailList = createAsyncThunk(
  'industry/fetchIndustryMappingDetailList',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');
      const response = await axios.get(`${config.apiURL}/getCompanyDetails`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return Array.isArray(response.data[0]) ? response.data[0] : [];
    } catch (error) {
      console.error('Error fetching industry mapping data:', error);
      return rejectWithValue(
        error.response?.data || 'Failed to fetch industry mapping details'
      );
    }
  }
);

// Fetch Dossier List Table
export const fetchDossierListTable = createAsyncThunk(
  'industry/fetchDossierListTable',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');
      const response = await axios.get(
        `${config.apiURL}/getDossierListDetails`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data || [];
    } catch (error) {
      console.error('Error fetching Dossier list:', error);
      return rejectWithValue(
        error.response?.data || 'Failed to fetch Dossier List Table'
      );
    }
  }
);

// Fetch Mapping Schema Table
export const fetchMappingSchemaTable = createAsyncThunk(
  'industry/fetchMappingSchemaTable',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');
      const response = await axios.get(
        `${config.apiURL}/getMappingSchemaDetails`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data || [];
    } catch (error) {
      console.error('Error fetching Mapping Schema table:', error);
      return rejectWithValue(
        error.response?.data || 'Failed to fetch Mapping Schema Table'
      );
    }
  }
);

const industrySlice = createSlice({
  name: 'industry',
  initialState,
  reducers: {
    clearIndustryMappingList: (state) => {
      state.industryMappingDetailList = [];
      state.DossierListTable = [];
      state.MappingSchemaTable = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Industry Mapping
      .addCase(fetchIndustryMappingDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustryMappingDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.industryMappingDetailList = action.payload;
      })
      .addCase(fetchIndustryMappingDetailList.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Dossier List
      .addCase(fetchDossierListTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDossierListTable.fulfilled, (state, action) => {
        // state.loading = false;
        state.DossierListTable = action.payload;
      })
      .addCase(fetchDossierListTable.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Mapping Schema Table
      .addCase(fetchMappingSchemaTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMappingSchemaTable.fulfilled, (state, action) => {
        // state.loading = false;
        state.MappingSchemaTable = action.payload;
      })
      .addCase(fetchMappingSchemaTable.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearIndustryMappingList } = industrySlice.actions;

export default industrySlice.reducer;
